<div class="pnc-detail-cancellation-section" data-cy="pnc-detail-cancellation-section">
    <div class="pnc-detail-old-part-number-section">
        <div class="pnc-detail-body-output-field-label detail">
            <span data-cy="pnc-detail-cancellation-label-old-part-number">Old part number</span>
        </div>
        <div class="pnc-detail-body-output-field-value detail"
             data-cy="pnc-detail-cancellation-old-part-number">{{$safeNavigationMigration(configuration?.oldPartNumber) | prettyPrintMaterialNumber}}</div>
    </div>

    <div class="pnc-detail-cancellation-reason-section">
        <div class="pnc-detail-body-output-field-label detail">
            <span data-cy="pnc-detail-cancellation-label-old-part-number">Cancellation reason</span>
        </div>
        <div class="pnc-detail-body-output-field-value detail"
             data-cy="pnc-detail-cancellation-old-part-number">{{$safeNavigationMigration(configuration?.cancellationReason) | undefinedValue}}</div>
    </div>

    <div class="pnc-detail-cancelled-by-section">
        <div class="pnc-detail-body-output-field-label detail">
            <span data-cy="pnc-detail-cancellation-cancelled-by">Cancelled by</span>
        </div>
        <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email detail"
             data-cy="pnc-detail-cancellation-cancelled-by-email"
        >{{$safeNavigationMigration(configuration?.cancelledBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    </div>
</div>
